import { useEffect, useState } from "react";
import DialogModal from "src/components/Dialog";
import InnerLoading from "src/components/InnerLoading";
import { AseobiAttire } from "src/utils/gql_types";
import Attire from "../Attire";
import AddNewAttire from "../modals/AddNewAttire";

interface Props {
  attires: AseobiAttire[] | undefined;
  groupId: string | undefined;
  groupName: string | null;
  loading: boolean;
}

const Attires = ({ attires, groupId, groupName, loading }: Props) => {
  const [open, setOpen] = useState(false);

  const [activeAttires, setActiveAttires] = useState<
    AseobiAttire[] | undefined
  >([]);

  useEffect(() => {
    setActiveAttires(attires?.filter((attire) => attire.active));
  }, [attires]);

  return (
    <div>
      <div className="mb-12 mt-4 flex w-full flex-col items-start gap-2 md:flex-row md:items-center md:justify-between">
        <h2 className="mb-4 text-[22px] font-semibold">
          {groupName === "regular" ? `Regular` : groupName}
        </h2>
        <DialogModal
          open={open}
          onOpenChange={setOpen}
          trigger={
            <button
              className="w-40 rounded-md bg-primary-5 py-2 text-white hover:bg-primary-1"
              onClick={() => setOpen(true)}
            >
              Add new attires
            </button>
          }
        >
          <AddNewAttire groupId={groupId} setOpen={setOpen} />
        </DialogModal>
      </div>
      {loading ? (
        <InnerLoading />
      ) : (
        <div className="flex flex-col gap-4">
          {activeAttires?.map((attire) => (
            <Attire attire={attire} key={attire.id} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Attires;
